export const messageBcPeerId = 4;
export const customMessage = 5;
//# sourceMappingURL=messageConstants.js.map